import { FilterChip } from "#/components/ui/filter-chip";
import { cn } from "#/lib/utils";
import type { Metric, Product, TimeRange } from "../hooks/use-portfolio-chart";

type Filters = {
	timeRange: TimeRange;
	product: Product;
	metric: Metric;
	setTimeRange: (next: TimeRange) => void;
	setProduct: (next: Product) => void;
	setMetric: (next: Metric) => void;
};

type Options = {
	timeRange: { value: TimeRange; label: string }[];
	product: { value: Product; label: string }[];
	metric: { value: Metric; label: string }[];
};

type Props = {
	filters: Filters;
	options: Options;
};

export function PortfolioChartFilterBar({ filters, options }: Props) {
	return (
		<div className="flex flex-wrap items-center justify-end gap-2 sm:gap-0 sm:divide-x sm:divide-border">
			<ChipGroup
				value={filters.timeRange}
				onChange={filters.setTimeRange}
				options={options.timeRange}
				className="sm:pr-2"
			/>
			<ChipGroup
				value={filters.product}
				onChange={filters.setProduct}
				options={options.product}
				className="sm:px-2"
			/>
			<ChipGroup
				value={filters.metric}
				onChange={filters.setMetric}
				options={options.metric}
				className="sm:pl-2"
			/>
		</div>
	);
}

function ChipGroup<T extends string>({
	value,
	onChange,
	options,
	className,
}: {
	value: T;
	onChange: (next: T) => void;
	options: { value: T; label: string }[];
	className?: string;
}) {
	return (
		<div className={cn("flex items-center gap-1", className)}>
			{options.map((opt) => (
				<FilterChip
					key={opt.value}
					active={opt.value === value}
					onClick={() => onChange(opt.value)}
				>
					{opt.label}
				</FilterChip>
			))}
		</div>
	);
}
